import { Injectable } from '@angular/core';
import {Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { VaService } from './va.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class VaListResolve  implements Resolve<any> {
    constructor(private _vaService: VaService) { }
    
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
      return this._vaService.getAgents().pipe(
        map((result) => {
          return true;
        }),
        catchError((err) => {
          return of(false);
        })
      );
    }
}